import React, { useState } from 'react';

import CloseIcon from '@material-ui/icons/Close';

import { Button, makeStyles, Dialog, DialogActions, DialogContent, FormHelperText, TextField, Typography } from '@material-ui/core';
import { FieldValidationError, ValidationHelper } from '../services/server/ServerResponses';
import { useIsMobile } from './Mui3WidthProvider';

const useStyles = makeStyles((theme) => ({
    container: {
        minWidth: '600px',
        [theme.breakpoints.down('sm')]: {
            minWidth: 'initial'
        },
    },
    closeMobileIcon: {
        color: "rgb(0, 0, 0, .4)",
        position: "absolute",
        top: 10,
        right: 10
    },
    titleRight: {
        float: 'right',
        paddingTop: 5,
        [theme.breakpoints.down('sm')]: {
            float: 'initial'
        },
    },
    mobileFormLabel: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0
        },
    },
    switchLabel: {
        fontWeight: 500,
        fontSize: 16
    },
    copyButton: {
        width: '100%',
        height: 51,
        backgroundColor: '#5bb2f6',
        marginBottom: 8,
        color: '#FFF',
        textAlign: 'center',
        verticalAlign: 'middle',
        "& span": {
            display: 'inline-block',
            marginTop: 16
        },
        cursor: 'pointer',

    },
    disabledButton: {
        backgroundColor: '#a7a7a7',
    },
    disabledText: {
        color: "#a7a7a7",
        pointerEvents: "none",
        cursor: "default"
    },
    urlInput: {
        maxHeight: 51,
        borderRadius: '0px',
        fontSize: '12px',
        [`& fieldset`]: {
            borderRadius: 0,
        }
    },
    listHorizontal: {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
    },
    listItem: {
        width: 70,
        "&:nth-of-type(2)": {
            width: 95
        }
    },
    socialIcons: {
        width: 40,
        height: 40,
        marginTop: -5
    },
    listItemSubContainer: {
        textAlign: 'center'
    },
    disabledAnchor: {
        pointerEvents: 'none',
        cursor: 'default',
        color: "#b4b4b4"
    },
    loadingContainer: {
        height: 375,
        width: 600,
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            height: 'auto',
            width: 'auto'
        },
    }
}));

export interface Props {
    onClose: () => void;
    isOpen: boolean;
    errors: FieldValidationError[];
    onSave: (title: string, description?: string) => void;
}

export function SaveAsTemplateDialog(props:Props){
    const [isDisabled, setIsDisabled] = useState(false);
    const [templateTitle, setTemplateTitle] = useState("");
    const [templateDescription, setTemplateDescription] = useState('');
    const isMobile = useIsMobile();
    const classes = useStyles();

    const handleSaveConfirm = async (e: React.FormEvent) => {
         e.preventDefault(); 
         setIsDisabled(true)
         await props.onSave(templateTitle, templateDescription);
         setIsDisabled(false)
    }
        
    return (
            <Dialog
            open={props.isOpen}
            onClose={() => props.onClose()}
            fullScreen={isMobile}
            disableEscapeKeyDown={isDisabled}
            disableBackdropClick={isDisabled}
        >
            <div className={classes.container}>
                {isMobile && <CloseIcon className={classes.closeMobileIcon} onClick={props.onClose} />}
                <form onSubmit={e => handleSaveConfirm(e) }>
                    <DialogContent>
                        <Typography variant="h6" component="h6">
                            Save As Custom Template
                        </Typography>
                        <TextField
                            required
                            autoFocus={true}
                            margin="dense"
                            label="Template Name"
                            type="text"
                            onChange={(e) => setTemplateTitle(e.target.value)}
                            fullWidth
                        />
                        {ValidationHelper.isFieldInError(props.errors, 'Name') &&
                            <FormHelperText error id="location-error-text"><span dangerouslySetInnerHTML={{ __html: ValidationHelper.getFieldErrorSummary(props.errors, 'Name') }} /></FormHelperText>
                        }
                        <TextField
                            margin="normal"
                            label="Template Description"
                            type="text"
                            multiline
                            rows={4}
                            rowsMax={4}
                            onChange={(e) => setTemplateDescription(e.target.value)}
                            fullWidth
                        />
                        {ValidationHelper.isFieldInError(props.errors, 'TemplateDescription') &&
                            <FormHelperText error id="location-error-text"><span dangerouslySetInnerHTML={{ __html: ValidationHelper.getFieldErrorSummary(props.errors, 'TemplateDescription') }} /></FormHelperText>
                        }
                        <DialogActions>
                            <Button color="primary" variant="contained" type="submit" disabled={isDisabled}>
                                Save As Template
                        </Button>
                        </DialogActions>
                    </DialogContent>

                </form>
            </div>
        </Dialog>
    );
}